module.exports = __webpack_public_path__ + "static/media/Graham Garland.7ddda67f.png";